export function formatarMoeda(valor?: number | null): string {
  if (valor == null) return '—'
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/** Converte 'yyyy-MM-dd' (ou ISO com hora) para Date local (sem deslocamento de fuso). */
export function parseDataLocal(data: string): Date {
  const [ano, mes, dia] = data.slice(0, 10).split('-').map(Number)
  return new Date(ano, (mes ?? 1) - 1, dia ?? 1)
}

export function formatarData(data?: string | null): string {
  if (!data) return '—'
  return parseDataLocal(data).toLocaleDateString('pt-BR')
}

/** Formata data e hora a partir de um ISO datetime. */
export function formatarDataHora(data?: string | null): string {
  if (!data) return '—'
  const d = new Date(data)
  if (Number.isNaN(d.getTime())) return formatarData(data)
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export const NOMES_MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
]

export const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
